module.exports = __webpack_public_path__ + "static/media/intelligence.f099642f.png";